import { DEFAULT_TASK_FOLDER_ID } from './../constants/todoConstants';
import { getTasksInTaskList } from './GraphService';

export const fetchPendingTasksForDefaultFolder = (): Promise<any> =>
    getTasksInTaskList(DEFAULT_TASK_FOLDER_ID, { $filter: "Status ne 'Completed'" });

export const fetchRecentlyCompletedTasksForDefaultFolder = (): Promise<any> =>
    getTasksInTaskList(DEFAULT_TASK_FOLDER_ID, {
        $filter: "Status eq 'Completed'",
        maxpagesize: 5,
    });
